import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

const TOCRow = ({
  header,
  header_icon: headerIcon,
  description,
  link,
  isNew,
  testingID,
  newDescription,
  intl
}) => (
  <div className="TOCRow flex middle">
    <div className={newDescription ? 'flex-basis-70' : 'flex-basis-90'}>
      <div className="flex middle">
        <h5>{intl.formatMessage(header)}</h5>
        { headerIcon }
        {isNew && <div className="h6 text-green margin-md-left"><FormattedMessage id="hosting.toc_row.new" defaultMessage="New"/></div>}
      </div>
      <p className="text-gray-600">{intl.formatMessage(description)}</p>
    </div>
    { newDescription &&
      <div className="flex-basis-20 flex" style={{ justifyContent: 'end' }}>
        <div>
          <div className="text-small text-green heavy"><FormattedMessage id="hosting.active_listings_panel.new_text" defaultMessage="New"/></div>
          <div className="heavy">{intl.formatMessage(newDescription)}</div>
        </div>
      </div>
    }
    <div className="flex-basis-10 text-right">
      <a
        className={classnames('btn btn-default btn-outlined-light')}
        href={link}
        data-testing-id={`${testingID}-edit-button`}
      >
        <FormattedMessage id="hosting.toc_row.edit_link_text" defaultMessage="Edit"/>
      </a>
    </div>
  </div>
);

TOCRow.propTypes = {
  header: PropTypes.object,
  header_icon: PropTypes.string,
  description: PropTypes.object,
  link: PropTypes.string,
  testingID: PropTypes.string,
  isNew: PropTypes.bool,
  newDescription: PropTypes.string,
  intl: intlShape
};

export default injectIntl(TOCRow);
